import React from 'react';

const SideBar = () => {
    return (
        <div className="sidebar">

            <div id="block-2" className="widget widget_block widget_search">
                <form role="search" method="get" action="#" className="wp-block-search__button-outside wp-block-search__text-button wp-block-search">
                    <div className="wp-block-search__inside-wrapper ">
                        <input type="search" id="wp-block-search__input-1" className="wp-block-search__input wp-block-search__input" name="s" value="" placeholder="" required="" />
                        <button type="submit" className="wp-block-search__button wp-element-button">Search</button>
                    </div>
                </form>
            </div>


            <div id="block-3" className="widget widget_block">
                <div className="is-layout-flow wp-block-group">
                    <div className="wp-block-group__inner-container">
                        <h2>Recent Posts</h2>

                        <ul className="wp-block-latest-posts__list wp-block-latest-posts">
                            <li><a className="wp-block-latest-posts__post-title" href="#">How I get my First Michelin Star of My Carrier</a></li>
                            <li><a className="wp-block-latest-posts__post-title" href="#">How We run our coffeshop Business</a></li>
                            <li><a className="wp-block-latest-posts__post-title" href="#">We are Introducing Indo Chinese Combo</a></li>
                        </ul>
                    </div>
                </div>
            </div>


            <div id="block-6" className="widget widget_block">
                <div className="is-layout-flow wp-block-group">
                    <div className="wp-block-group__inner-container">
                        <h2>Categories</h2>

                        <ul className="wp-block-categories-list wp-block-categories">
                            <li className="cat-item cat-item-3"><a href="">Snacks</a></li>
                            <li className="cat-item cat-item-3"><a href="">Desserts</a></li>
                            <li className="cat-item cat-item-3"><a href="">Drinks</a></li>
                            <li className="cat-item cat-item-3"><a href="">Chinese</a></li>
                        </ul>
                    </div>
                </div>
            </div>


            <div id="block-20" className="widget widget_block widget_tag_cloud">
                <h2>Tags</h2>
                <p className="wp-block-tag-cloud">
                    <a href="#" className="tag-cloud-link">Burger</a>
                    <a href="#" className="tag-cloud-link">Pizza</a>
                    <a href="#" className="tag-cloud-link">Icecream</a>
                    <a href="#" className="tag-cloud-link">Salad</a>
                    <a href="#" className="tag-cloud-link">Kabab</a>
                    <a href="#" className="tag-cloud-link">Chicken</a>
                </p>
            </div>

        </div>
    );
};

export default SideBar;